import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faFileAlt, faDownload } from '@fortawesome/pro-solid-svg-icons'
import { Dispatch } from './architecture/frontend/index'
import _ from 'lodash'
import Select from 'react-select'
import moment from 'moment'
import DatePicker from 'react-datepicker'

import React, {useCallback} from 'react'
import {useDropzone} from 'react-dropzone'

import "react-datepicker/dist/react-datepicker.css"

const statusBar = (props) => {
  const status = props.shipment?.status
  const sortedStatuses = _.sortBy((props.statuses ?? []), status => status.order)
  return (
    <div className='pa2 ba b--moon-gray br2 bg-white f7 fw4 flex flex-wrap' style={{flexShink:0}}>
      {
        sortedStatuses.map(sortStatus => {
          const statusSlug = sortStatus.slug
          return (
            <div className={'pt1 ph1 flex ' + (status === sortStatus.id && ' fw7 evonik-light-purple ')} style={{flexShink:0}}>
              <div>{sortStatus.name} </div>
              <div className='pl1'>{ statusSlug !== 'complete' && ' >' }</div>
            </div>
          )
        })
      }
      {/* <div className={'ph2 ' + (_.isNil(status) && 'fw7 evonik-light-purple ')}>Incomplete</div>  >  <div className={'ph2 ' + (status === 'submit-referee' && ' fw7 evonik-light-purple ')}>Submit Referee</div>  >  <div className='ph2'>Awaiting Referee</div>  >  <div className='ph2'>Requiring Payment</div>  >  <div className='ph2'>Complete</div> */}
    </div>
  )
}

const fileInput = (props) => {
  const value = props._value
  const display = value ? true : false
  return (
    <div className='pa2 w4 flex justify-center'>
      <MyDropzone _id={props.shipment.id}/>
      { display && <FontAwesomeIcon onClick={e => Dispatch.nextAction('shipment.refereeDownload', props.shipment?.id)} className='f4 pl3 pointer' icon={faDownload} style={{color: '#7bb093'}}/>
      }
    </div>
  )
}

function MyDropzone(props) {
  const onDrop = useCallback(acceptedFiles => {
    Dispatch.nextAction('shipment.refereeUpload', {file: acceptedFiles[0], id: props._id})
  }, [])
  const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})
  return (
    <div className='pointer' {...getRootProps()}>
      <input {...getInputProps()} />
      {
          isDragActive ?
          <FontAwesomeIcon className='f4 ' icon={faFileAlt} style={{color: '#7bb093'}}/> :
            <FontAwesomeIcon className='f4 ' icon={faFileAlt} style={{color: '#7bb093'}}/>
      }
    </div>
  )
}

const select = (props) => {
  const value = props._value
  const type=props._type
  const object=props._object
  const id=props._id
  const fullOptions = props._fullOptions
  const disabled = props._disabled
  const disabledStyle = disabled ? {pointerEvents: 'none'} : {}
  const disabledClass = disabled ? ' o-30 ' : ''
  const defaultValue = _.find(value, entry => entry.value === props._defaultValue)
  return (
    <div className={'w5 mt1 ' + disabledClass} style={{...disabledStyle}}>
            <Select options={value} defaultValue={defaultValue} onChange={e=>Dispatch.nextAction('__.buffer.setBuffer.' + type, {object, id, value: _.find(fullOptions, option => option.id === e.value)})}/>
      {/* <Select options={value} defaultValue={defaultValue} onChange={e=>Dispatch.nextAction('shipment.set', {type: updateType, value: e.value})}/> */}
    </div>
  )
}

const Text = (props) => {
  const type=props._type
  const id=props._id
  const object=props._object
  const size = props._large ? ' w5 ' : ' w4 '
  return (
    <div className={'mt1' + size}>
     <input 
      className='w-100 pa2 br2 bg-white f7 ba b--moon-gray ' 
      style={{ outline: 'none', borderStyle: 'solid' }} 
      type="text" 
      placeholder=''
      defaultValue={_.find(props[type]?.rawData, data => data.id === id)?.[object]}
      onChange={e=>Dispatch.nextAction('__.buffer.setBuffer.' + type, {object, id, value: e.target.value})}
    />
    </div>
  )
}

const date = (props) => {
  const value = props.shipment?.[props._updateType] && new Date(props.shipment?.[props._updateType])
  const updateType=props._updateType
  return (
    <div className='w4 mt1 ba b--moon-gray'>
      <DatePicker className='w-100 pa2 bn b--moon-gray input-reset' selected={value} onChange={e => Dispatch.nextAction('shipment.set', {type: updateType, value: moment(e)?.toISOString() ?? ''})} />
    </div>
  )
}

const entryTypes = {
  date: date,
  supplier: (props) => <div className='w5 mt1 ba b--moon-gray pa2 br2 bg-white fw4'>Test</div>,
  remarks: (props) => <div className=' mt1 pa2 ba b--moon-gray br2 bg-white fw4' >Remarks</div>,
  text: Text,
  select: select,
  status: statusBar,
  file: fileInput,
  claimDeniedDate: (props) => <> {props.shipment.claimDeniedDate ? <div className=' ph3 pv2 mb1 bg-light-yellow f7 dark-gray fw6'>Claim Denied on {props.shipment.claimDeniedDate && moment(props.shipment.claimDeniedDate).format('MMMM Do yyyy')}</div> : <div></div> }</>,
  refereedDate: (props) => <> {props.shipment.refereeDate ? <div className=' ph3 pv2 mb1 bg-light-yellow f7 dark-gray fw6'>Sent to Referee on {props.shipment.refereeDate}</div> : <div></div> }</>
}

const EntryItem = (props) => {
  const title = props._title
  const display = props._display
  const Child = entryTypes[display] //props._child
  return (
    <div className='flex items-center fw6 f7'>
      {title && <div className='w4 dark-gray tr'>{title}</div>}
      {<div className='dn w4 dark-gray tr'>break this</div>}
      <div className='pl4'>
        <Child {...props}/>
      </div>
    </div>
  )
}

export default EntryItem